/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Box, FlexContainer, Heading, Tag, Text, theme } from "@nordcloud/gnui";
import { BusinessContextSelectorOption } from "./types";

type Props = {
  item: BusinessContextSelectorOption;
  label?: string;
  onClick: () => void;
};

export function OrganisationUnitItem({ item, label, onClick }: Props) {
  return (
    <Box
      boxStyle="lightGrey"
      innerSpacing="spacing02"
      mb={theme.spacing.spacing02}
      css={{
        "&:hover": {
          cursor: "pointer",
          backgroundColor: theme.color.background.ui04,
        },
      }}
      onClick={onClick}
    >
      <FlexContainer>
        <FlexContainer alignItems="stretch">
          <div
            css={{
              flex: 1,
              marginRight: theme.spacing.spacing03,
              minHeight: "1rem",
              width: ".75rem",
              height: "100%",
              borderRadius: theme.radius.sm,
              backgroundColor: item.color || theme.color.background.ui05,
            }}
          />
        </FlexContainer>
        <div>
          <Text
            size="sm"
            tag="div"
            color={theme.color.text.text02}
            mb={theme.spacing.spacing01}
          >
            Business context
          </Text>
          <FlexContainer justifyContent="space-between">
            <Heading level={4}>{item.name}</Heading>
          </FlexContainer>
          {label && (
            <>
              <Text
                size="sm"
                tag="div"
                color={theme.color.text.text02}
                mb={theme.spacing.spacing01}
              >
                Selected Organizational Unit
              </Text>
              <Tag
                text={label}
                color={item.color || theme.color.background.ui05}
              />
            </>
          )}
        </div>
      </FlexContainer>
    </Box>
  );
}
